export class ShippingLine{
    id: number;
    name: string;
    createdDate: string;
    createdBy: string;
    updatedDate: string;
    updatedBy: string;
}


// WEBPACK FOOTER //
// ./src/app/models/shippingLines/shippingLine.ts